export const ShippingFeeLabelTextHelper = {
    getLabelText: {
        orderNumber: 'Order Number',
        marketplaceCode: 'Marketplace Code',
        shippingFeeAmount: 'Shipping Fee HKD'
    }
};
